import React from 'react';

export const SmallKeyIcon = ({ color = 'currentColor', ...restProps }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M5.82532 8.17303C5.43964 7.21103 5.39794 6.14536 5.70727 5.15616C6.01661 4.16696 6.658 3.3149 7.52303 2.74401C8.38807 2.17312 9.42369 1.91842 10.4548 2.02295C11.486 2.12748 12.4494 2.58483 13.1823 3.3177C13.9152 4.05058 14.3725 5.01402 14.4771 6.04517C14.5816 7.07632 14.3269 8.11194 13.756 8.97698C13.1851 9.84201 12.333 10.4834 11.3438 10.7927C10.3546 11.1021 9.28896 11.0604 8.32696 10.6747L8.327 10.6746L7.50349 11.4981H6.00254V12.999H4.50159V14.5H2V11.9984L5.82543 8.17298L5.82532 8.17303Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 6C11.6642 6 12 5.66421 12 5.25C12 4.83579 11.6642 4.5 11.25 4.5C10.8358 4.5 10.5 4.83579 10.5 5.25C10.5 5.66421 10.8358 6 11.25 6Z"
        fill={color}
        stroke={color}
      />
    </svg>
  );
};
